import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=3fc605a7&"
import script from "./ProductReviews.vue?vue&type=script&lang=ts&"
export * from "./ProductReviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports